import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import UserForm from '../../components/form/user-form';

export default function UserAdd() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Add User"}
                    is_main_page={false}
                />
                <UserForm
                    mode={'add'}
                    button_title={'Add'}
                />
            </Container>
        </>
    )
}